import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  dashboard: {
    id: 'sidebar.dashboard',
    defaultMessage: 'Dashboard',
  },
  estimation: {
    id: 'sidebar.estimation',
    defaultMessage: 'Estimates',
  },
  newEstimation: {
    id: 'sidebar.newEstimation',
    defaultMessage: 'Create new estimate',
  },
  wizardMode: {
    id: 'sidebar.wizardMode',
    defaultMessage: 'Estimation Wizard',
  },
  detailedEstimation: {
    id: 'sidebar.detailedEstimation',
    defaultMessage: 'Detailed Estimation',
  },
  notification: {
    id: 'sidebar.notification',
    defaultMessage: 'Notification',
  },
  aiAdvisory: {
    id: 'sidebar.aiAdvisory',
    defaultMessage: 'Estimation AI Advisory',
  },
  newConversation: {
    id: 'sidebar.newConversation',
    defaultMessage: 'New Conversation',
  },
  administration: {
    id: 'sidebar.administration',
    defaultMessage: 'Administration',
  },
  signOut: {
    id: 'sidebar.signOut',
    defaultMessage: 'Sign Out',
  },
});
